import * as React from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "../store/auth-context";
import LoginForm from "../components/forms/LoginForm";

export default function LoginPage() {
  const authCtx = React.useContext(AuthContext);

  if (authCtx.isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  const loginHandler = async (identifier: string, password: string) => {
    return authCtx.login({ identifier, password });
  };

  return (
    <LoginForm
      onSignIn={loginHandler}
      isLoading={authCtx.isLoading}
      error={authCtx.loginError}
    />
  );
}
